import { RootState } from '../../../applicationStore';
import { JobState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getJobState = (state: RootState): JobState => state.job;

export const getJobLoader = createSelector(
  getJobState,
  (state): boolean => state.loading,
);

export const getJobData = createSelector(
  getJobState,
  (state): JobState['data'] | null => state?.data || null,
);
